<template>
    <div
        :id="id+_uid"
        ref="editor"
        contenteditable="true" 
        :value="value"
        :class="classnames"
    />
</template>

<script>
    export default {
        name: 'CKEditor',
        props: {
            value: {
                type: String,
                default: '',
            },
            params: {
                type: Object,
                default: null 
            },
            id: {
                type: String,
                default: 'editor'
            },
            blockid: {
                type: Number,
                default: 0,
            },
            autofocus: {
                type: Boolean,
                default: true,
            },
            showalways: {
                type: Boolean,
                default: false,
            },
            singleline: {
                type: Boolean,
                default: false,
            },
            classnames: {
                type: String,
                default:''
            }
        },
        data: function() {
            return {
                config: this.params || {},
                ready: false,
            }
        },
        beforeUpdate () {
            const ckeditorId = this.id+this._uid
            if (this.value !== CKEDITOR.instances[ckeditorId].getData()) {
                CKEDITOR.instances[ckeditorId].setData(this.value)
            }
        },
        mounted () {
            const component = this;
            const ckeditorId = this.id+this._uid;
            CKEDITOR.disableAutoInline = true;
            CKEDITOR.inline(ckeditorId, this.config);
            CKEDITOR.instances[ckeditorId].setData(this.value);

            if (this.singleline) {
                CKEDITOR.instances[ckeditorId].on('key', function(e) {
                   var key = e.data.keyCode;      
                   if(key==13 || key==2228237){
                      return false;
                   }
                });
            }

            CKEDITOR.instances[ckeditorId].on('change', (e) => {
                let editorInstance = CKEDITOR.instances[ckeditorId];
                if (editorInstance) {
                    const ckeditorData = editorInstance.getData();
                    if (ckeditorData !== this.value) {
                        this.$emit('input', ckeditorData)
                    }
                }
            });

            if (this.showalways) {
                CKEDITOR.instances[ckeditorId].on('blur', (e) => {
                   return false;
                });
            }

            CKEDITOR.on( 'dialogDefinition', function( ev ) {
                ev.data.definition.resizable = CKEDITOR.DIALOG_RESIZE_NONE;
            });

            CKEDITOR.on('instanceReady',function(e){
                this.ready = true;
                component.$emit('ready');
            });

            if (this.autofocus) {
                component.$refs.editor.focus();
            }
        },
        setData (value) {
            this.value = value;
            CKEDITOR.instances[ckeditorId].setData(value);
        },
        beforeDestroy() {
            const ckeditorId = this.id+this._uid;
            if (CKEDITOR.instances[ckeditorId]) {
                CKEDITOR.instances[ckeditorId].destroy()
            }
        },

    }
</script>
